import styled from 'styled-components';

import {
  BounceInLeft, 
  BounceInRight,
  BounceInUp,
  BounceInDown, 
} from './animation'

export const Wrap = styled.div`
  width: 380px;
  position: fixed;
  z-index: 10010;

  ${props => {
    switch (props.position) {
      case 'top-left':
        return `
          top: 1em;
          left: 1em;
        `
      case 'top-center':
        return `
          top: 1em;
          left: 50%;
          transform: translate(-50%, 0);
        `
      case 'top-right':
        return `
          top: 1em;
          right: 1em;
        `
      case 'bottom-left':
        return `
          bottom: 1em;
          left: 1em;
        `
      case 'bottom-center':
        return `
          bottom: 1em;
          left: 50%;
          transform: translate(-50%, 0);
        `
      case 'bottom-right':
        return `
          bottom: 1em;
          right: 1em;
        `
      default:
        break;
    }
  }};

  .toast {
    color: #fff;
    border-radius: 3px;
    animation-duration: 750ms;
    animation-fill-mode: both;

    ${props => {
      switch (props.position) {
        case 'top-left':
          return `animation-name: ${BounceInLeft};`
        case 'top-center':
          return `animation-name: ${BounceInDown}`
        case 'top-right':
          return `animation-name: ${BounceInRight}`
        case 'bottom-left':
          return `animation-name: ${BounceInLeft}`
        case 'bottom-center':
          return `animation-name: ${BounceInUp}`
        case 'bottom-right':
          return `animation-name: ${BounceInRight}`
        default:
          break;
      }
    }};

    & + div {
      margin-top: 10px;
    }
    
    &.info {
      background-color: ${props => props.colors && props.colors.info ? props.colors.info : '#527D5A'};
    }
    &.success {
      background-color: ${props => props.colors && props.colors.success ? props.colors.success : '#3366ff'};
    }
    &.warning {
      background-color: ${props => props.colors && props.colors.warning ? props.colors.warning : '#E78644'};
    }
    &.error {
      background-color: ${props => props.colors && props.colors.error ? props.colors.error : '#ee4035'};
    }
    &.alarm {
      background-color: ${props => props.colors && props.colors.alarm ? props.colors.alarm : '#3e4040'};
    }
  }


`


// WEBPACK FOOTER //
// ./client/components/Toast/Container/styled.js